module.exports = __webpack_public_path__ + "static/media/views.359bba1e.png";